<template>
  <div class="text-center mt-5">
    <h1>ERROR 404</h1>
    <h2>URL not found</h2>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
